// extracted by mini-css-extract-plugin
export default {"p_content":"d0882d7ece"};